import { Constraint } from '@occc/graphql';

export type ConstraintBlockId =
  | 'ActivationRequiredConstraint'
  | 'FulfillmentWindowConstraint'
  | 'EmailRequiredConstraint'
  | 'OrderAheadOnlyConstraint'
  | 'InStoreOnlyConstraint'
  | 'FulfillmentChannelConstraint'
  | 'PaymentMethodConstraint'
  | 'PaymentInstrumentConstraint'
  | 'PurchaseThresholdConstraint'
  | 'PurchasableEligibilityConstraint'
  | 'PurchaseEligibleProductGroupConstraint'
  | 'VoucherStackingConstraint'
  | 'BreakageRefundConstraint'
  | 'BreakagePointRoundingConstraint'
  | 'AudienceConstraint'
  | 'StateConstraint'
  | 'SubBrandConstraint'
  | 'ExcludedStoresConstraint'
  | 'IncludedStoresConstraint'
  | 'StoreLocationGroupConstraint';

export type ConstraintBlocksVisibility = Partial<Record<ConstraintBlockId, boolean>>;
export type ConstraintBlocksByConstraint = Record<ConstraintBlockId, Constraint['__typename'][]>;

export const CONSTRAINT_TYPE_NAMES_TO_BLOCKS_MAPPING: ConstraintBlocksByConstraint = {
  ActivationRequiredConstraint: ['ConstraintRequiresActivation'],
  FulfillmentWindowConstraint: ['ConstraintDaysOfWeek', 'ConstraintTimeOfDay'],
  EmailRequiredConstraint: ['ConstraintEmailRequired'],
  OrderAheadOnlyConstraint: ['ConstraintOrderAheadOnly'],
  InStoreOnlyConstraint: ['ConstraintInStoreOnly'],
  FulfillmentChannelConstraint: ['ConstraintOrderAheadOnly', 'ConstraintInStoreOnly'],
  PaymentMethodConstraint: ['ConstraintPaymentMethod'],
  PaymentInstrumentConstraint: ['ConstraintPaymentInstrument'],
  PurchaseThresholdConstraint: ['ConstraintPurchaseThreshold'],
  PurchasableEligibilityConstraint: ['ConstraintPurchasableEligibility'],
  PurchaseEligibleProductGroupConstraint: ['ConstraintPurchaseThreshold'],
  VoucherStackingConstraint: ['ConstraintRequiresTransactionVoucher'],
  BreakageRefundConstraint: ['ConstraintRequiresTransactionVoucher'],
  BreakagePointRoundingConstraint: ['ConstraintRequiresTransactionVoucher'],
  AudienceConstraint: ['ConstraintInAudience'],
  StateConstraint: ['ConstraintLocationInState'],
  SubBrandConstraint: ['ConstraintSubBrand'],
  IncludedStoresConstraint: ['ConstraintStoreLocation'],
  ExcludedStoresConstraint: ['ConstraintStoreLocation'],
  StoreLocationGroupConstraint: ['ConstraintStoreLocationGroup'],
};

export const CONSTRAINTS_SECTION_BLOCKS: ConstraintBlockId[] = [
  'ActivationRequiredConstraint',
  'FulfillmentWindowConstraint',
  'EmailRequiredConstraint',
  'OrderAheadOnlyConstraint',
  'InStoreOnlyConstraint',
  'FulfillmentChannelConstraint',
  'PaymentMethodConstraint',
  'PaymentInstrumentConstraint',
  'PurchaseThresholdConstraint',
  'PurchasableEligibilityConstraint',
  'PurchaseEligibleProductGroupConstraint',
  'VoucherStackingConstraint',
  'BreakageRefundConstraint',
  'BreakagePointRoundingConstraint',
];

export const TARGETING_SECTION_BLOCKS: ConstraintBlockId[] = [
  'AudienceConstraint',
  'StateConstraint',
  'SubBrandConstraint',
  'IncludedStoresConstraint',
  'ExcludedStoresConstraint',
  'StoreLocationGroupConstraint',
];
